import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=4aed4275"
import script from "./Distribution.js?vue&type=script&lang=js&external"
export * from "./Distribution.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports